/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { IrrSddcTrustRelationship } from './irrSddcTrustRelationship';
import { IrrSaasOAuthApp } from './irrSaasOAuthApp';


export interface IrrSddcAuth { 
    oauth?: IrrSaasOAuthApp;
    trust?: Array<IrrSddcTrustRelationship>;
}

